var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "categories" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "warning", disabled: _vm.loading },
                    on: { click: _vm.allclick },
                  },
                  [_vm._v("排序")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableDataSortable,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  align: "center",
                  label: "品类名称",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌/品种",
                  prop: "tag",
                  minWidth: "100px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "tag-wrap" }, [
                          _c(
                            "div",
                            { staticClass: "tag-box" },
                            _vm._l(scope.row.tags, function (child) {
                              return _c(
                                "span",
                                { key: child.id, staticClass: "tag" },
                                [_vm._v(_vm._s(child.name))]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_audit",
                  align: "center",
                  width: "100px",
                  label: "是否需要审核",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.is_audit == 1 ? "是" : "否") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "item.prop",
                  align: "center",
                  label: "是否显示二级分类",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            width: 32,
                            "active-value": 1,
                            "active-text": "显示",
                            "active-color": "#409EFF",
                            "inactive-value": 0,
                            "inactive-text": "隐藏",
                            "inactive-color": "#C0CCDA",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.openSwitch(
                                scope.$index,
                                scope.row,
                                scope.row.is_show
                              )
                            },
                          },
                          model: {
                            value: scope.row.is_show,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "is_show", $$v)
                            },
                            expression: "scope.row.is_show",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "品类排序",
            visible: _vm.drawer,
            direction: "rtl",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "draggableTable",
                  attrs: {
                    data: _vm.tableData,
                    "row-key": "id",
                    stripe: "",
                    height: "100%",
                    border: true,
                    "header-cell-style": {
                      color: "#333333",
                      background: "#EFF6FF",
                    },
                  },
                  on: { "row-dragged": _vm.handleRowDragged },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "100",
                      align: "center",
                      label: "序号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "名称" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "item.prop",
                      align: "center",
                      label: "操作",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("i", { staticClass: "el-icon-rank" })]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseSwitch,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(
              "您确定要" +
                _vm._s(_vm.dataState == 0 ? "隐藏" : "显示") +
                "该品类吗？"
            ),
          ]),
          _vm.dataState == 0
            ? _c(
                "div",
                { staticClass: "mt-10", staticStyle: { color: "red" } },
                [_vm._v(" 隐藏后该品类的所有商品将自动下架 ")]
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseSwitch } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.changeSwitch } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }